import { render, staticRenderFns } from "./Dialog_GoToStudent.vue?vue&type=template&id=39519fe0&scoped=true&"
import script from "./Dialog_GoToStudent.vue?vue&type=script&lang=js&"
export * from "./Dialog_GoToStudent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39519fe0",
  null
  
)

export default component.exports